import {
  IVideoMutationForm,
  IVideoResponse,
  TRACK_CENSORIOUS,
} from "services/video/types";

export const videoQueryToForm = (
  videoQuery: IVideoResponse,
): IVideoMutationForm => {
  const { videoStatus, ...video } = {
    ...videoQuery,
    censorious: videoQuery.censorious ?? TRACK_CENSORIOUS.unknown,
    genre:
      videoQuery.genre !== null && videoQuery.genre.id !== -1
        ? { id: videoQuery.genre.id, name: videoQuery.genre.name }
        : { id: -1, name: "" },
    status: videoQuery.videoStatus,
    isrc: videoQuery.isrc ?? "",
    pline: videoQuery.pline?.name?.length
      ? videoQuery.pline
      : { name: "", year: -1 },
    cline: videoQuery.cline?.name?.length
      ? videoQuery.cline
      : { name: "", year: -1 },
    artists: videoQuery.artists.map(({ rolePlacement, ...artist }) => ({
      ...artist,
    })),
    isInstrumental: videoQuery.instrumental,
  };

  return video;
};
